import makeClickable from "../../common/makeClickable.js";

export default () => {
  document.querySelectorAll(".js-promo-clickable").forEach(makeClickable);
};